import router from '../router'
import store from '../store'
import NProgress from 'nprogress' // progress bar

// NProgress.configure({ showSpinner: false })// NProgress configuration

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  next()
  NProgress.start()
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/utils/permission.js